var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3305 50.4266C15.0777 48.6173 7.2373 39.6913 7.2373 28.956C7.2373 17.0145 17.0076 7.24414 28.9492 7.24414C40.8907 7.24414 50.661 17.0145 50.661 28.956C50.661 39.6913 42.8206 48.6173 32.5678 50.4266L31.3616 49.4617H26.5367L25.3305 50.4266Z",
    fill: "url(#paint0_linear_344_5404)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3927 34.9869L38.3577 28.9559H32.5678V24.7341C32.5678 23.0454 33.171 21.7186 35.8246 21.7186H38.5989V16.17C37.0308 15.9287 35.3421 15.6875 33.7741 15.6875C28.8286 15.6875 25.3306 18.703 25.3306 24.131V28.9559H19.9026V34.9869H25.3306V50.3059C26.5368 50.5471 27.743 50.6677 28.9492 50.6677C30.1554 50.6677 31.3616 50.5471 32.5678 50.3059V34.9869H37.3927Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_344_5404",
    x1: 28.9492,
    y1: 49.1649,
    x2: 28.9492,
    y2: 7.24414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0062E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19AFFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.876a628339a48d9d5104ad3edde39991.svg";
export { ForwardRef as ReactComponent };